import type { RouteRecordRaw } from 'vue-router'
import { getComponent } from '../utils'
import MainLayout from '@/layouts/crew-connect/main-layout.vue'
import LoginLayout from '@/layouts/crew-connect/login-layout.vue'

export const crew_connect_routes: RouteRecordRaw[] = [
  {
    path: '/crew-connect',
    name: 'crew-connect-index',
    redirect: `/crew-connect/home`
  },
  {
    path: '/crew-connect/welcome',
    name: 'crew-connect-welcome',
    component: () => getComponent(`pages/crew-connect/welcome.vue`),
    meta: { title: () => 'Welcome', layout: MainLayout, is_public: true }
  },
  {
    path: '/crew-connect/home',
    name: 'crew-connect-home',
    component: () => getComponent(`pages/crew-connect/home.vue`),
    meta: { title: () => 'Home', layout: MainLayout, is_public: true }
  },
  {
    path: '/crew-connect/call-time',
    name: 'crew-connect-call-time',
    component: () => getComponent(`pages/crew-connect/call-time.vue`),
    meta: { title: () => 'Call Time', layout: MainLayout, is_public: true }
  },
  {
    path: '/crew-connect/locations',
    name: 'crew-connect-locations',
    component: () => getComponent(`pages/crew-connect/locations.vue`),
    meta: { title: () => 'Locations', layout: MainLayout, is_public: true }
  },
  {
    path: '/crew-connect/members',
    name: 'crew-connect-members',
    component: () => getComponent(`pages/crew-connect/members.vue`),
    meta: { title: () => 'Members', layout: MainLayout, is_public: true }
  },
  {
    path: '/crew-connect/signup',
    name: 'crew-connect-signup',
    component: () => getComponent(`pages/crew-connect/signup.vue`),
    meta: { title: () => 'Signup', layout: MainLayout, is_public: true }
  },
  {
    path: '/crew-connect/login',
    name: 'crew-connect-login',
    component: () => getComponent(`pages/crew-connect/login.vue`),
    meta: { title: () => 'Login', layout: LoginLayout, is_public: true }
  },
  {
    path: '/crew-connect/login-email',
    name: 'crew-connect-login-email',
    component: () => getComponent(`pages/crew-connect/login-email.vue`),
    meta: { title: () => 'Login', layout: LoginLayout, is_public: true }
  },
  {
    path: '/crew-connect/login-sms',
    name: 'crew-connect-login-sms',
    component: () => getComponent(`pages/crew-connect/login-sms.vue`),
    meta: { title: () => 'Login', layout: LoginLayout, is_public: true }
  },
  {
    path: '/crew-connect/logout',
    name: 'crew-connect-logout',
    component: () => getComponent(`pages/crew-connect/logout.vue`),
    meta: { title: () => 'Logout', layout: MainLayout, is_public: true }
  }
]
